<template>
  <div class="container">
    <span class="landscape_error" v-show="$store.getters['app/overlays'].show_landscape_error">
      <p id="text_error">Please set device to landscape</p>
    </span>

    <span class="main_background">
      <img v-if="selected_text > 0" draggable="false" class="clickable" id="quit_btn_top" @click="goBack()" src="./assets/images/Asset 29.png" alt="">

      <span v-if="! play_canopy">
        <video id="video" muted="muted" loop playsinline>
          <source src="./assets/background.mp4" type="video/mp4" />
        </video>
      </span>
      <!-- <span v-else>
        <iframe id="video" src="http://localhost:8000/examples/360.html" frameborder="0"></iframe>
      </span> -->

      <span v-if="selected_text > -1">
        <span v-html="texts[selected_text]" id="intro_text" :style="selected_text > 0 ? 'margin-top: 6%;' : ''"></span>

        <img draggable="false" class="clickable" v-show="texts.length > (selected_text + 1)" @click="nextText()" id="next_btn" src="./assets/images/Asset 51.png" alt="">
        <img draggable="false" class="clickable" v-show="selected_text > 0" @click="prevText()" id="prev_btn" src="./assets/images/Asset 51.png" alt="">

        <img v-show="texts.length == (selected_text + 1)" draggable="false" @click="playCanopy()" class="clickable" id="start_btn" src="./assets/images/Asset 32.png" alt="">
      </span>
    </span> 
  </div>

</template>

<script>

export default {
  // https://stackoverflow.com/questions/22429866/embed-youtube-videos-that-play-in-fullscreen-automatically
  name: 'App',

  mounted() {
    document.getElementById('video').play();
    this.checkLandscape();
  },

  created() {
    window.addEventListener("resize", this.checkLandscape);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkLandscape);
  },

  data() {
    return {
      selected_text: 0,
      texts: [
        "De film genaamd \"Under the Canopy\" neemt je mee naar de magische wereld van het Amazone-regenwoud, een plek vol prachtige bomen, wilde dieren en spannende avonturen. Kamanja Panashekung, een lid van een inheemse gemeenschap die altijd in het regenwoud heeft gewoond heeft een heel bijzonder verhaal te vertellen. Hij werkt hard om het regenwoud te beschermen, want dat is zijn thuis. Maar zijn verhaal is niet zomaar een spannend verhaal, het is eigenlijk een heel belangrijk stukje geschiedenis.",
        
        "Al meer dan 30 jaar werkt Conservation International samen met lokale vrienden om dit geweldige regenwoud te redden. Waarom? Omdat het regenwoud goed is voor ons allemaal. Het helpt de planeet gezond te houden en zorgt voor schone lucht en water.",
        
        "Dus, als je deze film bekijkt, leer je niet alleen over de prachtige natuur en geweldige avonturen in het Amazone-regenwoud, maar ook over hoe we allemaal kunnen samenwerken om onze planeet te beschermen.",
      ],
      play_canopy: false,
    };
  },

  methods: {
    playCanopy() {
      // this.play_canopy = true
      // this.selected_text = window.open('http://localhost:8000/examples/360.html', '_blank');

      window.open('http://localhost:8000', '_blank');

      // setTimeout(function() {
      //   document.getElementById('video').play();
      //   var video= document.getElementById('video');
      //   video.muted = !video.muted; 
      // }, 1000);
    },
    goBack() {
      this.play_canopy = true
      this.selected_text = 0
    },
    nextText() {
      this.selected_text++;
    },
    prevText() {
      this.selected_text--;
    },
    checkLandscape() {
      if ( window.innerWidth < ( window.innerHeight * 1.5 ) ) {
        if ( ! this.$store.getters['app/overlays'].show_landscape_error )
          this.$store.dispatch('app/asyncUpdateLandscapeOverlay', {
            show_landscape_error: true
          });
      } else {
        if ( this.$store.getters['app/overlays'].show_landscape_error )
          this.$store.dispatch('app/asyncUpdateLandscapeOverlay', {
            show_landscape_error: false
          });
      }
    }
  },

  computed: {},

  watch: {}
}
</script>

<style>
  .landscape_error {
    background-color: grey;
    width: 105%;
    height: 105%;
    position: absolute;
    z-index: 3;
  }

  #text_error {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 25%;
    color: white;
    width: 95%;
    font-size: 5.5vw;
    text-align: center;
  }

  @font-face {
    font-family: "LuckiestGuy";
    src: url('./assets/fonts/LuckiestGuy-Regular.ttf') format('truetype');
  }

  #text_intro_header {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 6%;
    width: 50%;
    left: 25%;
    color: #000;
    font-size: 5vw;
    text-align: center;
  }
  #intro_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 13%;
    width: 60%;
    left: 20%;
    color: #000;
    font-size: 2.1vw;
    text-align: center;
  }

  .container {
    margin: -10px;
  }

  .main_background {
    position: absolute;
    z-index: -1;
  }

  #video {
    width: 100%;
    height: auto;
  }

  body {
    cursor: url('./assets/cursor/material-wood-cursor.png'), default;	
  }

  .clickable {
    cursor: url('./assets/cursor/material-wood-pointer.png'), default;
  }

  #quit_btn_top {
    position: absolute;
    margin-top: 2%;
    right: 3%;
    width: 15%;
    z-index: 3;
  }

  #start_btn {
    position: absolute;
    margin-top: 20%;
    left: 40%;
    width: 20%;
  }

  #start_btn:hover {
    opacity: 0.9;
    -webkit-filter: drop-shadow(5px 5px 5px #8f8f8f);
    filter: drop-shadow(5px 5px 5px #8f8f8f);
  }

  #next_btn {
    position: absolute;
    margin-top: 44%;
    left: 73%;
    width: 5%;
  }
  #prev_btn {
    transform: rotate(180deg);
    position: absolute;
    margin-top: 44%;
    left: 20%;
    width: 5%;
  }

  body {
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
    background-color: black;
  }
</style>
